import { Projects } from './models';
import { Settings } from './models/project';

const agentHas = (keyword: string) => {
  return navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
};

const transformDate = (date: string) => {
  const [dateStr] = date.split(' ');
  const d = dateStr.split('-');
  const fullDate = new Date(+d[0], +d[1] - 1, +d[2]);
  const month = fullDate.toLocaleString('default', { month: 'long' });
  return `${month} ${+d[2]}, ${+d[0]}`;
};

export const isSafari = () => {
  return (
    (!!(window as any).ApplePaySetupFeature || !!(window as any).safari) &&
    agentHas('Safari') &&
    !agentHas('Chrome') &&
    !agentHas('CriOS')
  );
};

export const validateEmail = (email: string) => {
  const re =
    /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let isValid = 0;
  if (email === '') {
    isValid = 1;
  } else if (re.test(email) === false) {
    isValid = 2;
  }
  return isValid;
};

export const getMapProjects = (projects: Projects[]) => {
  const rows = [];

  projects &&
    projects.length > 0 &&
    projects.forEach((element: any) => {
      const data = {
        name: element.displayName ?? element.Name,
        id: element.Name ? element.Name : element.owner_workspace,
        edited: element?.file_info?.last_date ? transformDate(element?.file_info?.last_date) : '-',
        rows: element?.file_info?.rows ? element?.file_info?.rows : '-',
        columns: element?.file_info?.columns ? element?.file_info?.columns : '-',
        size: element?.file_info?.size ? element?.file_info?.size : '-',
        kind:
          element?.shared_emails && element?.shared_emails?.length > 0
            ? 'SharedTo'
            : element?.owner_workspace
            ? 'Shared File'
            : 'File',
        date: element?.file_info?.last_date,
        ownerEmail: element?.owner_workspace ? element?.owner_email : 'Me',
        sharedEmails: element?.shared_emails ?? null
      };
      rows.push(data as never);
    });
  rows.sort(function (a, b) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return new Date(b.date) - new Date(a.date);
  });
  return rows;
};

export const getLocalStorage = (localDataKey: any) => {
  let localData = localStorage.getItem(localDataKey);
  localData = localData ? JSON.parse(localData) : localData;
  return localData;
};

export const setLocalStorage = (localDataKey: any, localDataValue: any) => {
  localStorage.setItem(localDataKey, JSON.stringify(localDataValue));
};

export const uploadFile = (url: string, file: any, success: any, error: any) => {
  const xhr = new XMLHttpRequest();
  xhr.open('PUT', url);
  xhr.onload = success;
  xhr.onerror = error;
  xhr.send(file);
};

export const refreshSettingsGridCells = (gridRef: any, row?: any) => {
  const gridApi = (gridRef.current as any)?.api;
  if (row) {
    gridApi?.refreshCells(row);
  } else gridApi?.refreshCells();
};

export const getWorkspace = (location: string) => {
  const workspace = location.split('/');
  let id = workspace[2];
  return id;
};

export const validateExpiredToken = (page: any) => {
  // check this out again with the new library 18/9
  let gridChangesBack;
  let groupedViewsBack;
  let groupRollbackListBack;
  let totalChanges = 0;
  let totalGroupChanges = 0;
  let totalRollbackList = 0;
  gridChangesBack = getLocalStorage('setGridChanges');
  totalChanges = gridChangesBack?.length;
  groupedViewsBack = getLocalStorage('setGroupedViews');
  totalGroupChanges = groupedViewsBack?.length;
  groupRollbackListBack = getLocalStorage('setgroupRollbackList');
  totalRollbackList = groupRollbackListBack ? Object.entries(groupRollbackListBack)?.length : 0;
  if (totalChanges > 0 || totalGroupChanges > 0 || totalRollbackList > 0) {
    setLocalStorage('timeExpired', true);
  }
  if (page) setLocalStorage('lastPageStored', page);

  const token = getLocalStorage('token');
  if (token) {
    setLocalStorage('token', null);
    setLocalStorage('userData', null);
  }
  window.open('/', '_self');
};

export const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * max);
};

export const getRandomString = () => {
  const words = ['ab', 'bc', 'cd', 'de', 'ef', 'gh', 'zi', 'ap', 'ao', 'xq'];
  return words[Math.floor(Math.random() * words.length)];
};

export const checksNoAnswer = (uniqueEntries, sortedValues) => {
  const noAnswerSortedValues = !!sortedValues?.find((r) => r == 'No Answer');
  return !noAnswerSortedValues && uniqueEntries && uniqueEntries.length > 0
    ? uniqueEntries.some((r) => r === 'No Answer' || r === null)
    : false;
};

export const checksValues = (sortedValues, unique_values, countValues, preview) => {
  return (
    (sortedValues?.length > 0 && countValues < 60
      ? sortedValues
      : unique_values?.length > 0 && countValues < 60
      ? unique_values
      : preview) || []
  );
};

export const getConvertDataProjects = (project: any, isMultipleChoice?: boolean) => {
  try {
    const settings = project?.settings ?? project;
    const objects = Object.keys(settings)?.map((key) => [key, settings[key]]);
    const settingsArr: Settings[] = [];
    objects.forEach((element) => {
      let data: any = {};
      let uniqueValuesCount =
        typeof element[1]?.unique_count === 'string'
          ? parseInt(element[1]?.unique_count, 10)
          : element[1]?.unique_count;
      const hasCutModified =
        element[1]?.vtype === 'ordinal' ? element[1]?.cutting_rule?.includes('@') : null;
      const totalSegmentsModified =
        element[1]?.vtype === 'ordinal' ? element[1]?.cutting_rule?.split('@')?.length : 0;
      const segmentsValue =
        element[1]?.vtype === 'ordinal'
          ? element[1]?.sortedValues?.length > 0
            ? element[1]?.sortedValues?.length
            : element[1]?.cutting_rule
            ? !hasCutModified
              ? element[1]?.cutting_rule?.split('u')[1]?.trim()
              : totalSegmentsModified
            : ''
          : '';

      const typeKind = element[1].is_numeric
        ? 'number'
        : element[1].is_date
        ? 'date'
        : element[1].is_string
        ? element[1]?.extra_turned_to_date
          ? 'date'
          : element[1]?.extra_turned_to_number
          ? 'number'
          : 'text'
        : 'text';
      const existsNoAnswer = checksNoAnswer(element[1]?.unique_entries, element[1]?.sortedValues);

      if (element[1].GroupName !== '') {
        data = {
          ...element[1],
          // columnName: element[1]?.label ? element[1].label :
          originalColumnName: element[1]?.columnName?.trim(),
          columnName:
            element[1].GroupAttr &&
            element[1].GroupAttr.length > 0 &&
            element[1].GroupName !== element[1].GroupAttr &&
            (element[1].columnName?.includes(':') ||
              element[1].columnName?.includes('_') ||
              element[1].columnName?.includes('-') ||
              element[1].columnName?.includes('?'))
              ? element[1].GroupAttr
              : element[1].columnName?.trim(),
          id: element[0],
          countValues: uniqueValuesCount,
          segments:
            element[1]?.cutting_rule !== 'num2str'
              ? element[1]?.cutting_rule === `f ${element[1]?.unique_values?.length}` &&
                element[1]?.unique_values?.length > 0 &&
                !element[1]?.cutting_rule?.includes('@')
                ? element[1]?.unique_values?.length
                : element[1]?.cutting_rule === 'f 3' ||
                  element[1]?.cutting_rule === 'f 2' ||
                  element[1]?.cutting_rule === 'f 1'
                ? element[1]?.cutting_rule?.split(' ')[1]
                : element[1]?.cutting_rule?.includes('@')
                ? element[1]?.cutting_rule.split('@').length
                : element[1]?.cutting_rule?.length > 0 &&
                  element[1]?.cutting_rule !== `f ${element[1]?.unique_values?.length}`
                ? 1
                : ''
              : '',
          // element[1]?.vtype === 'ordinal' && segmentsValue
          //   ? Number(segmentsValue)
          //     ? Number(segmentsValue)
          //     : ''
          //   : '',
          columnNameServer: element[1].columnName?.trim(),
          // element[1].columnName?.includes(':') ||
          // element[1].columnName?.includes('_') ||
          // element[1].columnName?.includes('-') ||
          // element[1].columnName?.includes('?')
          //   ? element[1].columnName?.trim()
          //   : null,
          preview: element[1].preview,
          dataType: element[1].is_numeric
            ? 'number'
            : element[1].is_date
            ? 'date'
            : element[1].is_string
            ? element[1]?.extra_turned_to_date
              ? 'date'
              : element[1]?.extra_turned_to_number
              ? 'number'
              : 'text'
            : 'text',
          type: typeKind,
          fieldPosition:
            element[1].method == 'multiplechoice'
              ? element[1]?.fieldPosition
              : parseInt(element[1]?.fieldPosition, 10),
          analyzer: typeKind == 'text' && parseFloat(element[1]?.specificity) > 0.9
        };
      } else {
        data = {
          ...element[1],
          id: element[0],
          countValues: uniqueValuesCount,
          segments:
            element[1]?.cutting_rule !== 'num2str'
              ? element[1]?.cutting_rule === `f ${element[1]?.unique_values?.length}` &&
                element[1]?.unique_values?.length > 0 &&
                !element[1]?.cutting_rule?.includes('@')
                ? element[1]?.unique_values?.length
                : element[1]?.cutting_rule === 'f 3' ||
                  element[1]?.cutting_rule === 'f 2' ||
                  element[1]?.cutting_rule === 'f 1'
                ? element[1]?.cutting_rule?.split(' ')[1]
                : element[1]?.cutting_rule?.includes('@')
                ? element[1]?.cutting_rule.split('@').length
                : element[1]?.cutting_rule?.length > 0 &&
                  element[1]?.cutting_rule !== `f ${element[1]?.unique_values?.length}`
                ? 1
                : ''
              : '',
          // element[1]?.vtype === 'ordinal' && segmentsValue
          //   ? Number(segmentsValue)
          //     ? Number(segmentsValue)
          //     : ''
          //   : '',
          // columnName: element[1]?.label ? element[1].label : element[1].columnName,
          // columnNameServer: element[1]?.label ? element[1].label : element[1].columnName,
          columnNameServer: element[1].columnName?.trim(),
          preview: element[1].preview,
          originalColumnName: element[1]?.columnName?.trim(),
          columnName: element[1]?.label?.trim(), //  element[1]?.columnName?.trim(),
          columnNamePivot: element[1]?.columnName?.trim().replace(/\./g, ' '),
          dataType: element[1].is_numeric
            ? 'number'
            : element[1].is_date
            ? 'date'
            : element[1].is_string
            ? element[1]?.extra_turned_to_date
              ? 'date'
              : element[1]?.extra_turned_to_number
              ? 'number'
              : 'text'
            : 'text',
          type: typeKind,
          fieldPosition: parseInt(element[1]?.fieldPosition, 10),
          analyzer: typeKind == 'text' && parseFloat(element[1]?.specificity) > 0.9
        };
      }

      if (existsNoAnswer) {
        if (data.sortedValues) data.sortedValues.push('No Answer');
        else data.sortedValues = ['No Answer'];
      }

      settingsArr.push(data);
    });

    if (!isMultipleChoice) {
      settingsArr.sort((a, b) =>
        a.fieldPosition > b.fieldPosition ? 1 : b.fieldPosition > a.fieldPosition ? -1 : 0
      );
    }

    const mapData = {
      processed: project.processed,
      headers: project.headers,
      UID: project.UID,
      settings: settingsArr
    };
    return mapData;
  } catch (error) {
    console.error(error);
  }
};

export const getDataWithGroupedViews = (views) => {
  const groupViews: any[] = [];
  let sameGroup = false;
  const groupsName: string[] = [];
  if (views && views.length > 0) {
    views.forEach((element) => {
      if (
        (element?.GroupName && element?.GroupName !== '' && !sameGroup) ||
        (element?.GroupName &&
          element?.GroupName !== '' &&
          !groupsName.includes(element?.GroupName))
      ) {
        const groupData: any = {
          GroupName: element.GroupName,
          columnName: element.GroupName,
          isParent: true,
          method: element.method,
          separator: element.separator,
          exclude: element.exclude
        };
        sameGroup = true;
        groupsName.push(element.GroupName);
        groupViews.push(groupData);
      } else if (element.GroupName === '') {
        sameGroup = false;
      }
      groupViews.push(element);
    });
  }
  return groupViews;
};

export const getViewsAndBreakDownList = (project: any) => {
  const data = getConvertDataProjects(project);
  let group = '';
  const mapData = data?.settings?.map((x: Settings) => {
    let hasGroup = false;
    const valuesFromGroup: string[] = [];

    if (x.GroupName && x.GroupName?.length > 0 && group !== x.GroupName) {
      group = x.GroupName;
      hasGroup = true;
      const dataFilterd = data?.settings.filter((y) => y.GroupName === x.GroupName);
      dataFilterd.forEach((element: any) => {
        const values =
          element?.sortedValues?.length > 0 ? element.sortedValues : element.unique_values;
        for (let index = 0; index < values?.length; index++) {
          valuesFromGroup.push(values[index]);
        }
      });
    }
    return {
      view:
        !hasGroup && x.GroupName?.length === 0
          ? x.columnName
          : hasGroup && x.GroupName?.length > 0
          ? x.GroupName
          : null,
      values: [],
      backupValues: [],
      breakDown:
        !hasGroup && x.GroupName?.length === 0
          ? x.columnName
          : hasGroup && x.GroupName?.length > 0
          ? x.GroupName
          : null,
      exclude: x.exclude,
      isParent: hasGroup && x.GroupName?.length > 0 ? true : false,
      specificity: x.specificity,
      uniqueCount: typeof x.unique_count === 'string' ? parseFloat(x.unique_count) : x.unique_count,
      segments:
        x?.cutting_rule !== 'num2str'
          ? x?.cutting_rule === `f ${x?.unique_values?.length}` &&
            x?.unique_values?.length > 0 &&
            !x?.cutting_rule?.includes('@')
            ? x?.unique_values?.length
            : x?.cutting_rule === 'f 3' || x?.cutting_rule === 'f 2' || x?.cutting_rule === 'f 1'
            ? x?.cutting_rule?.split(' ')[1]
            : x?.cutting_rule?.includes('@')
            ? x?.cutting_rule.split('@').length
            : x?.cutting_rule?.length > 0 && x?.cutting_rule !== `f ${x?.unique_values?.length}`
            ? 1
            : ''
          : '',
      // x.cutting_rule === 'f 3' ||
      // x.cutting_rule === `f ${x.unique_values?.length}` ||
      // x.cutting_rule?.includes('@')
      //   ? x.unique_values?.length
      //   : 0,
      type: x.is_numeric
        ? 'number'
        : x.is_date
        ? 'date'
        : x.is_string
        ? x?.extra_turned_to_date
          ? 'date'
          : x?.extra_turned_to_number
          ? 'number'
          : 'text'
        : '',
      sort: 'asc',
      originalView:
        !hasGroup && x.GroupName?.length === 0
          ? x.columnNameServer
          : hasGroup && x.GroupName?.length > 0
          ? x.GroupName
          : null,
      cutting_rule: x.cutting_rule
    };
  });
  return mapData;
};

function normalizeInput(input) {
  return input.split(/\s+/).filter(Boolean).join(' ');
}

export function splitIntoPhrasesPanel(input, references) {
  input = normalizeInput(input);
  const result = [];

  for (let reference of references) {
    while (input.includes(reference)) {
      const index = input.indexOf(reference);
      const before = input.substring(0, index).trim();
      const after = input.substring(index + reference.length).trim();

      if (before !== '') {
        const parts = before.split(',');
        for (let part of parts) {
          if (part.trim() !== '') {
            result.push(part.trim() as never);
          }
        }
      }

      result.push(reference as never);

      if (after !== '') {
        input = after;
      } else {
        input = '';
      }
    }
  }

  const parts = input.split(',');
  for (let part of parts) {
    if (part.trim() !== '') {
      result.push(part.trim() as never);
    }
  }

  return result;
}

export function splitIntoPhrases(input: string, references: string[]): string[] {
  const normalizeInput = (str: string): string => str.trim();
  input = normalizeInput(input);
  const result: string[] = [];

  const isBalanced = (str: string): boolean => {
    let count = 0;
    for (const char of str) {
      if (char === '(') count++;
      if (char === ')') count--;
      if (count < 0) return false;
    }
    return count === 0;
  };

  const regex = /\(([^)]+)\)/g;
  let match: RegExpExecArray | null;

  const protectedSubstrings: string[] = [];
  while ((match = regex.exec(input)) !== null) {
    if (isBalanced(match[0])) {
      protectedSubstrings.push(match[0]);
      input = input.replace(match[0], `@@@${protectedSubstrings.length - 1}@@@`);
    }
  }

  for (const reference of references) {
    while (input.includes(reference)) {
      const index = input.indexOf(reference);
      const before = input.substring(0, index).trim();
      const after = input.substring(index + reference.length).trim();

      if (before !== '') {
        const parts = before.split(',');
        for (const part of parts) {
          if (part.trim() !== '') {
            result.push(part.trim());
          }
        }
      }

      result.push(reference);

      if (after !== '') {
        input = after;
      } else {
        input = '';
      }
    }
  }

  const parts = input.split(',');
  for (const part of parts) {
    if (part.trim() !== '') {
      result.push(part.trim());
    }
  }

  for (let i = 0; i < protectedSubstrings.length; i++) {
    const placeholder = `@@@${i}@@@`;
    result.forEach((item, index) => {
      if (item.includes(placeholder)) {
        result[index] = item.replace(placeholder, protectedSubstrings[i]);
      }
    });
  }

  return result;
}

export const getFilterItemsWithComma = (dataCheck, view: string) => {
  const singleRowsWithComma: string[] = [];
  const dataVals = dataCheck.filter((e) => e.view === view);
  dataVals[0]?.values?.forEach((element) => {
    if (element.name.includes(',')) {
      singleRowsWithComma.push(element.name);
    }
  });
  return singleRowsWithComma;
};

export function findMatches(array, str) {
  return array.filter((item) => str.includes(item.name));
}

export const getFilterViewDataReports = (payload: any, childWithComma?: any, menuViewData?) => {
  let filterArray = {};

  const realOnes: any = [];
  const itemsComma: any = [];

  if (typeof payload.filters == 'string') {
    let obj = {};
    let splitValues;
    const match =
      menuViewData && menuViewData?.values
        ? findMatches(menuViewData?.values, payload.filters)
        : [];

    match.forEach((element) => {
      const exists = menuViewData.values?.find((e) => e.name == element.name);
      if (exists) {
        realOnes.push(element.name);
        if (element.name.includes(',')) {
          itemsComma.push(element.name);
        }
      }
    });
    splitValues = splitIntoPhrases(payload.filters, itemsComma);
    // }
    const noSpaces: any[] = [];
    splitValues.forEach((element) => {
      noSpaces.push(element.trim());
    });
    return splitValues;
  } else {
    payload.filters?.forEach((element) => {
      let obj = {};
      element.children = element.children.toString().split(',  ').join(', ');
      let valuesElement =
        menuViewData && menuViewData.values ? menuViewData.values : menuViewData ?? [];
      if (menuViewData && !valuesElement.values && menuViewData.length > 0) {
        valuesElement = menuViewData.find((e) => e.view == element.parent).values;
      }
      const match = valuesElement ? findMatches(valuesElement, element.children) : [];
      let atLeastOneValueWithComma = false;
      match.forEach((element) => {
        const exists = valuesElement?.find((e) => e.name == element.name);
        if (exists) {
          realOnes.push(element.name);
          if (element.name.includes(',')) {
            itemsComma.push(element.name);
          }
        }
      });
      let splitValues;
      if (element.children && element.children.includes(',') && menuViewData) {
        // if (!childWithComma) {
        //   splitValues = element.children.split(',');
        // } else {

        const reference = typeof childWithComma == 'string' ? [childWithComma] : childWithComma;
        splitValues = splitIntoPhrases(element.children, reference ?? itemsComma);
        // }
        const noSpaces: any[] = [];
        splitValues.forEach((element) => {
          noSpaces.push(element.trim());
        });
        obj = {
          [element.parent]: noSpaces
        };
      } else if (!childWithComma) {
        splitValues = element.children
          ?.split(',')
          .map((e) => (typeof e === 'string' ? e.trim() : e));
        //element.children.split(',');
        obj = {
          [element.parent]: splitValues
        };
      } else {
        obj = {
          [element.parent]: [element.children]
        };
      }
      filterArray = { ...filterArray, ...obj };
    });

    return filterArray;
  }
};

export const getClusterSelected = (clusterData: any, clusterSelected: string) => {
  return (
    clusterData &&
    clusterData.length &&
    clusterData.find((cluster) => cluster.name === clusterSelected)
  );
};

export const hasChecked360Views = (viewDataSelected: any, type: string) => {
  let isChecked = false;
  const viewsSelected = viewDataSelected?.filter((e) => e.values.length > 0);
  viewsSelected?.forEach((element) => {
    element?.values?.forEach((element) => {
      if (type === 'analysis' && element.analyzeChecked) {
        isChecked = true;
      } else if (type === 'comparison' && element.compareChecked) {
        isChecked = true;
      } else if (type === 'both' && (element.compareChecked || element.analyzeChecked)) {
        isChecked = true;
      }
    });
  });

  return isChecked;
};

export const roundNumber = (num: number, decimals: number) => {
  return num ? Number(num.toFixed(decimals)) : num;
};

export const roundDown = (num: number, decimals: number) => {
  const factor = Math.pow(10, decimals);
  return Math.floor(num * factor) / factor;
};

export const removeDuplicates = (arr) => {
  return arr.filter((item, index) => arr.indexOf(item) === index);
};

export const removeDuplicatesByKey = (arr: any[], key: string) => {
  const seen = new Set();
  return arr.filter((item) => {
    const value = item[key];
    if (seen.has(value)) {
      return false;
    }
    seen.add(value);
    return true;
  });
};

export const hasPoints = (word) => {
  let hasPoints = false;
  if (/\./.test(word)) {
    hasPoints = true;
  }
  return hasPoints;
};

export const handleOpenEmail = (email?) => {
  const recipientEmail = email && email?.length > 0 ? email : 'support@drumroll.ai';
  const subject = '';
  const body = '';
  const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
  window.location.href = mailtoLink;
};

export const TruncatedCellRenderer = ({ value }: { value: any }) => {
  return (
    <span className="truncate" title={value}>
      {value}
    </span>
  );
};

export const formatNumber = (number: any) => {
  const userLocale = navigator.language;
  const numConvert =
    typeof number == 'number'
      ? number
      : typeof number == 'string' && !number.includes(',')
      ? parseFloat(number)
      : number;
  return typeof numConvert == 'number' ? numConvert.toLocaleString(userLocale) : number;
};

export const sumTotal = (props) => {
  const numbers = props.values;
  const numberArray = numbers.map((str) => {
    if (typeof str === 'string' && (str.includes(',') || str.includes('.'))) {
      return parseFloat(str.replace(/[,.](?=\d{3})/g, ''));
    }
    // return parseInt(str, 10);
    return parseFloat(str);
  });

  const sum = numberArray.reduce(
    (accumulator, currentValue) => accumulator + parseFloat(currentValue),
    0
  );
  return sum ? formatNumber(sum) : '';
};

export const addSpacesAfterSlash = (value: string) => {
  return typeof value === 'string'
    ? value.replace(/\/+/g, ' / ').replace(/\s*\/\s*/g, ' / ')
    : value;
};

export const splitFileName = (fileName: string) => {
  const parts = fileName.split(/\.(?=[^.]+$)/);
  const name = parts[0];
  const extension = parts[1];

  return { name, extension };
};

export const getTextColorClusterClass = (id: number) => {
  id = id - 1;
  const condition = id % 7;

  if (condition === 0) {
    return 'text-[#E7811D]';
  } else if (condition === 1) {
    return 'text-[#186677]';
  } else if (condition === 2) {
    return 'text-[#8E151F]';
  } else if (condition === 3) {
    return 'text-[#8E6401]';
  } else if (condition === 4) {
    return 'text-[#003452]';
  } else if (condition === 5) {
    return 'text-[#2E7A33]';
  } else if (condition === 6) {
    return 'text-[#47315E]';
  }
  return '';
};

export const getBorderClusterClass = (id: number) => {
  id = id - 1;
  const condition = id % 7;

  if (condition === 0) {
    return 'border-[#fd8f2280] border-[1px] bg-[#FD8F2226]';
  } else if (condition === 1) {
    return 'border-[#186677] border-[1px] bg-[#CCEDF5]';
  } else if (condition === 2) {
    return 'border-[#8E151F] border-[1px] bg-[#FADCDF]';
  } else if (condition === 3) {
    return 'border-[#8E6401] border-[1px] bg-[#FEE6AE]';
  } else if (condition === 4) {
    return 'border-[#003452] border-[1px] bg-[#D6F0FF]';
  } else if (condition === 5) {
    return 'border-[#003452] border-[1px] bg-[#D9FCEB]';
  } else if (condition === 6) {
    return 'border-[#47315E] border-[1px] bg-[#EAE4F1]';
  }
  return '';
};

export const hasDuplicatesArray = (array) => {
  const conjunto = new Set(array);

  return conjunto.size !== array.length;
};

export const isDecimal = (value: number) => {
  return value % 1 !== 0;
};

export const getOnlyYears = (values) => {
  const dates: string[] = [];

  values.forEach((element) => {
    dates.push(element.name);
  });

  const onlyyears = new Set();

  dates.forEach((date) => {
    const year = new Date(date).getFullYear();
    onlyyears.add(year);
  });

  return Array.from(onlyyears) || [];
};

export const dateFormats = {
  'YYYY-MM-DD': '%Y-%m-%d',
  'YYYY-MM': '%Y-%m',
  'MM-YYYY': '%m-%Y',
  'MMM-YYYY': '%b-%Y',
  'MM-DD': '%m-%d',
  'MMM-DD': '%b-%d',
  'MM-DD-YY': '%m-%d-%y',
  'MM-DD-YYYY': '%m-%d-%Y',
  'DD-MM-YYYY': '%d-%m-%Y',
  'DD-MM-YY': '%d-%m-%y',
  'DD-MM': '%d-%m',
  'DD-MMM': '%d-%b',
  'DD-MMM-YYYY': '%d-%b-%Y'
};

export const checksViewChecked = (view: string, showMore) => {
  let isChecked = false;
  const viewSelected = showMore?.find((e) => e.view === view);
  if (viewSelected) {
    isChecked = viewSelected.checked;
  } else if (showMore.length === 1 && showMore.find((e) => !e.view)) {
    const initial = showMore.find((e) => !e.view);
    if (!initial?.view) isChecked = true;
  } else if (showMore.length === 1 && !showMore.find((e) => !e.view)) {
    const checksView = showMore.find((e) => e.view === view);
    if (!checksView) isChecked = true;
  }
  return isChecked;
};

export const checksOldFiles = (rows?: any) => {
  const filesData: any = getLocalStorage('originalSettingsDataInitial') ?? [];
  const dataUpdated: any[] = [];
  if (filesData && filesData.length > 0) {
    filesData.forEach((file) => {
      if (
        file &&
        file?.file_info &&
        file.completed === 'yes' &&
        rows &&
        rows.find((e) => e.id === file.Name)
      ) {
        dataUpdated.push(file);
      }
    });
    setLocalStorage('originalSettingsDataInitial', dataUpdated);
  }
};

export const getCurrentDateMMDDYY = () => {
  const currentDate = new Date();
  const month = ('0' + (currentDate.getMonth() + 1)).slice(-2);
  const day = ('0' + currentDate.getDate()).slice(-2);
  const year = currentDate.getFullYear().toString().slice(-2);
  const formattedDate = `${month}/${day}/${year}`;

  return formattedDate;
};

const addZeroForward = (num) => {
  return num < 10 ? `0${num}` : num;
};

export const getCurrentTimeStamp = () => {
  const now = new Date();
  const hours = now.getHours();
  const mins = now.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  const horas12 = hours % 12 || 12;
  const timeStamp = `${addZeroForward(horas12)}:${addZeroForward(mins)} ${ampm}`;
  return timeStamp;
};

export const removeQuotes = (str) => {
  const match = str.match(/^"(.*)"$/);
  return match ? match[1] : str;
};

export const getAIBubleData = (bubles: any, step: number) => {
  return bubles && bubles.length > 0
    ? bubles.find((e) => e?.step == step || e?.index == step)
    : undefined;
};

export const isReportsMultiple = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 11 == 0;
};

export const isReportsMultipleLearn = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 59 == 0;
};

export const isReportsBackMainScreen = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 19 == 0;
};

export const isReportsChangeColumn = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 23 == 0;
};

export const isCohortsMultiple = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 13 == 0;
};

export const isCohortsMultipleLearn = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 61 == 0;
};

export const isCohortsChangeColumn = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 29 == 0;
};

export const isCohortsBackMainScreen = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 73 == 0;
};

export const isCohortsMultipleLoop = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 37 == 0;
};

export const isSignalsMultiple = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 67 == 0;
};

export const isSignalsMultipleLearn = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 71 == 0;
};

export const isSignalsBackMainScreen = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 53 == 0;
};

export const isSignalsChangeColumn = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 79 == 0;
};

export const isSignalsMultipleLoop = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 41 == 0;
};

export const isCorrelationMultiple = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 17 == 0;
};

export const isCorrelationMultipleLearn = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 47 == 0;
};

export const isCorrelationBackMainScreen = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 83 == 0;
};

export const isCorrelationsChangeColumn = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 31 == 0;
};

export const isCorrelationsMultipleLoop = (x: any) => {
  if (x == 0.1 || x == 0.3 || x == 0.2) return false;
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 43 == 0;
};

export const isErrorMultipleLoop = (x: any) => {
  if (typeof x === 'string') {
    x = parseInt(x, 10);
  }
  return x % 89 == 0;
};

export const getCleanNumber = (value: string) => {
  const numberWithoutCommas =
    typeof value === 'string' ? value?.replace(/,/g, '') : String(value).replace(/,/g, '');
  if (!numberWithoutCommas.includes('.')) {
    return numberWithoutCommas;
  }
  const number = parseFloat(numberWithoutCommas);
  if (number > 999 || number.toString().split('.')[1].length > 2) {
    return numberWithoutCommas.replace(/[,.]/g, '');
  } else {
    return value;
  }
};

export const sortAndGetMenuLongValues = (
  response: any,
  payload: any,
  viewDataSelected: any,
  newValues: any,
  breakDown: any,
  type?: string,
  isAlreadySortedByDesc?: boolean
) => {
  const dataSelected = response?.data?.data ?? response;
  dataSelected.forEach((element) => {
    const viewSelected = payload.view
      ? payload.view
      : payload.viewSelected
      ? payload.viewSelected
      : viewDataSelected.view;

    if (breakDown && element[breakDown]) {
      if (element[viewSelected] !== '*' && element[breakDown] === '*') {
        const viewInfo = viewDataSelected?.values?.find((e) => e.name == element[viewSelected]);
        if (viewInfo) {
          let colData = {
            name: viewInfo.name,
            count: element?.count,
            checked: viewInfo?.checked ?? false
          };
          newValues.push(colData);
        }
      }
    } else {
      if (element[viewSelected] !== '*') {
        const viewInfo = viewDataSelected?.values?.find((e) => e.name == element[viewSelected]);
        if (viewInfo) {
          let colData = {
            name: viewInfo.name,
            count: element?.count,
            checked: viewInfo?.checked ?? false
          };
          newValues.push(colData);
        }
      }
    }
  });

  if (newValues.length < viewDataSelected.values.length && type !== 'date') {
    viewDataSelected.values.forEach((el) => {
      const exists = newValues.find((r) => r.name == el.name);
      let colData = {};
      if (!exists) {
        colData = {
          name: el.name,
          count: 0,
          checked: el.checked
        };
        newValues.push(colData);
      }
    });
  }

  const sortByName = true;
  if (sortByName && !isAlreadySortedByDesc) {
    newValues.sort((a, b) => {
      const valueA = String(a.name);
      const valueB = String(b.name);
      return valueA.localeCompare(valueB);
    });
  } else if (isAlreadySortedByDesc) {
    newValues.sort((a, b) => {
      const valueA = String(a.name);
      const valueB = String(b.name);
      return valueB.localeCompare(valueA);
    });
  }

  return newValues;
};

export const checksReportsGridDataForDates = (response, field, viewSelected, viewData) => {
  const dataInsert: any[] = [];
  response.data?.data?.forEach((element) => {
    if (element[field] !== '*') {
      dataInsert.push({
        [viewSelected]: element[field],
        count: element?.count,
        pct: element.pct
      });
    }
  });
  const res = {
    [viewSelected]: response.data[field],
    data: dataInsert,
    type:
      viewData && viewData.length > 0
        ? viewData.find((e) => e.view === viewSelected)?.dataType
        : '',
    view: viewSelected
  };
  return res;
};

export const checksReportsGridDataForBreakdownDates = (
  response,
  viewSelected,
  viewData,
  breakDownSelected,
  isViewSelectedDateType,
  views
) => {
  const dataInsert: any[] = [];
  response.data?.data?.forEach((element) => {
    if (
      element[views[0]] &&
      element[breakDownSelected] &&
      element[views[0]] !== '*' &&
      element[breakDownSelected] !== '*' &&
      isViewSelectedDateType
    ) {
      dataInsert.push({
        [viewSelected]: element[views[0]],
        [breakDownSelected]: element[breakDownSelected],
        count: element?.count,
        pct: element.pct
      });
    } else if (
      element[viewSelected] &&
      element[views[1]] &&
      element[viewSelected] !== '*' &&
      element[views[1]] !== '*' &&
      !isViewSelectedDateType
    ) {
      dataInsert.push({
        [viewSelected]: element[viewSelected],
        [breakDownSelected]: element[views[1]],
        count: element?.count,
        pct: element.pct
      });
    }
  });
  const res = {
    [viewSelected]: isViewSelectedDateType ? response.data[views[0]] : response.data[viewSelected],
    [breakDownSelected]: isViewSelectedDateType
      ? response.data[breakDownSelected]
      : response.data[views[1]],
    data: dataInsert,
    type:
      viewData && viewData.length > 0
        ? viewData.find((e) => e.view === viewSelected)?.dataType
        : '',
    view: viewSelected
  };
  return res;
};

export const checksIfNoSpaces = (word: string) => {
  const hasNotSpace = word && typeof word === 'string' ? word?.indexOf(' ') === -1 : false;
  return hasNotSpace;
};

export const addCommas = (array) => {
  let arr = typeof array == 'string' ? array.split(',').map((value) => value.trim()) : array;
  const res = arr?.reduce((acc, str, index) => {
    if (index !== 0) {
      acc.push(' , ');
    }
    acc.push(str);
    return acc;
  }, []);
  const finalRes = res.join('');
  return finalRes;
};

export const getCurrentDate = () => {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = currentDate.getFullYear();
  const formattedDate = `${month}-${day}-${year}`;
  return formattedDate;
};

export const scrollToManyView = (view: string, from: string) => {
  setTimeout(() => {
    const element = document.getElementById(`${view}--id`);
    if (element) {
      const val = `${view}-${from}`;
      const clickedEl = val.replace(/\s+/g, '-');
      if (!element.hasAttribute(clickedEl)) {
        element.click();
        element.setAttribute(clickedEl, 'true');
        setTimeout(() => {
          const itemStyle = document.getElementById(view) as any;
          if (itemStyle?.style?.display) {
            itemStyle.style.display = 'block';
          }
        }, 1500);
      }
    }
  }, 1000);
};

export const scrollToView = (view: string, from: string) => {
  setTimeout(() => {
    const element = document.getElementById(`${view}--id`);
    if (element) {
      element.scrollIntoView({ behavior: 'auto' });
      const val = `${view}-${from}`;
      const clickedEl = val.replace(/\s+/g, '-');
      if (
        (from === 'cohorts' || from === 'signals' || from === 'correlation') &&
        !element.hasAttribute(clickedEl)
      ) {
        element.click();
        element.setAttribute(clickedEl, 'true');
      }
    }
  }, 1500);
};

export const toCamelCase = (str: any) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const extractColumnsFromRefresh = (msg: string) => {
  let columnsRemoved;
  let columnsAdded;

  const match = msg.match(/These columns were not found: (.+?)\./);
  const matchNew = msg.match(/These columns are new: (.+?)\./);
  if (match && match[1]) {
    columnsRemoved = match[1].split(', ').map((column) => ({ deleted: column.trim() }));
  }
  if (matchNew && matchNew[1]) {
    columnsAdded = matchNew[1].split(', ').map((column) => ({ added: column.trim() }));
  }

  return {
    columnsRemoved,
    columnsAdded
  };
};

export const checksGreetingAIHistory = (history) => {
  return !!(
    (history.bublesLoaded &&
      history.bublesLoaded.length > 0 &&
      history.bublesLoaded.find((e) => e.index >= -2)) ||
    history.date != getCurrentDateMMDDYY()
  );
};

export const checksFileDescAIHistory = (history) => {
  return !!(
    (history.bublesLoaded &&
      history.bublesLoaded.length > 0 &&
      history.bublesLoaded.find((e) => e.index >= -1.75)) ||
    history.date != getCurrentDateMMDDYY()
  );
};

export const checksShowMeAIHistory = (history) => {
  return !!(
    (history.bublesLoaded &&
      history.bublesLoaded.length > 0 &&
      history.bublesLoaded.find((e) => e.index >= -1)) ||
    history.date != getCurrentDateMMDDYY()
  );
};

export const checksShowMeAIHistory2 = (history) => {
  return !!(
    (history.bublesLoaded &&
      history.bublesLoaded.length > 0 &&
      history.bublesLoaded.find((e) => e.index >= -1.5)) ||
    history.date != getCurrentDateMMDDYY()
  );
};

export const checksGreatMsgAIHistory = (history) => {
  return (
    (history.bublesLoaded &&
      history.bublesLoaded.length > 0 &&
      history.bublesLoaded.find((e) => e.index == 1)) ||
    false
  );
};

export const checksMostImportatColAI = (history) => {
  return (
    (history.bublesLoaded &&
      history.bublesLoaded.length > 0 &&
      history.bublesLoaded.find((e) => e.index == 2)) ||
    false
  );
};

export const checksReportsDataAI = (history, bubble) => {
  return (
    history.bublesLoaded &&
    history.bublesLoaded.length > 0 &&
    ((history.bublesLoaded.find((e) => e.index == 2) &&
      bubble.error &&
      getAIBubleData(history?.bubles, bubble.step)?.finish) ||
      (history.bublesLoaded.find((e) => e.index == 2) &&
        bubble.reply &&
        !isReportsMultiple(bubble.step) &&
        !isCohortsChangeColumn(bubble.step) &&
        !isSignalsChangeColumn(bubble.step) &&
        !isCorrelationsChangeColumn(bubble.step)) ||
      (history.bublesLoaded.find((e) => e.index == 3) &&
        bubble.finish &&
        !isReportsChangeColumn(bubble.step) &&
        !isCohortsChangeColumn(bubble.step) &&
        !isSignalsChangeColumn(bubble.step) &&
        !isCorrelationsChangeColumn(bubble.step) &&
        !isReportsMultiple(bubble.step)) ||
      (history.bublesLoaded.find((e) => e.index == bubble.step) &&
        isReportsMultiple(bubble.step) &&
        getAIBubleData(history?.bubles, bubble.step)?.finish))
  );
};

export const cleanStorage = () => {
  localStorage.removeItem('trial-expired-modal');
  localStorage.removeItem('dashboardPopoverOptions');
  localStorage.removeItem('popoverOpts');
  localStorage.removeItem('errorUploadFile');
  localStorage.removeItem('storingAI');
  localStorage.removeItem('segmentsStored');
  localStorage.removeItem('columnSignalsAI');
  localStorage.removeItem('filteredTargets');
  localStorage.removeItem('FilesSelected');
  localStorage.removeItem('typechk');
  localStorage.removeItem('colGridValue');
  localStorage.removeItem('firstTimeCluster');
  localStorage.removeItem('colsAdded');
  localStorage.removeItem('goingPageFromMyViews');
  localStorage.removeItem('checksDoneSignalsAI');
  localStorage.removeItem('rowsItemsShared');
  localStorage.removeItem('handleActivated');
  localStorage.removeItem('goAnyWayFlag');
  localStorage.removeItem('dropdown-ai');
  localStorage.removeItem('AIHistoryChecked');
  localStorage.removeItem('sentCohortPayload');
  localStorage.removeItem('flowbite-theme-mode');
  localStorage.removeItem('sentReportsPayload');
  localStorage.removeItem('firstRender');
  localStorage.removeItem('popupChecked500Values');
  localStorage.removeItem('myviewsPopoverOptions');
  localStorage.removeItem('theme');
  localStorage.removeItem('colsRemoved');
  localStorage.removeItem('sentCorrelationPayload');
  localStorage.removeItem('lastoneShareItem');
  localStorage.removeItem('selectAllValues');
  localStorage.removeItem('endChkChangeValue');
  localStorage.removeItem('firstRenderTrends');
  localStorage.removeItem('isRealTopic');
  localStorage.removeItem('showClusterCard');
  localStorage.removeItem('hasRows');
  localStorage.removeItem('onceCallViews');
  localStorage.removeItem('sortedHandled');
  localStorage.removeItem('checksDoneCorrelationAI');
  localStorage.removeItem('sentSignalsPayload');
  localStorage.removeItem('setGridChanges');
  localStorage.removeItem('count-apply-settings');
  localStorage.removeItem('cohorts-size');
  localStorage.removeItem('trends-data');
  localStorage.removeItem('trends-data-quarter');
  localStorage.removeItem('trends-headers');
  localStorage.removeItem('trends-headers-quarter');
  localStorage.removeItem('open-reports-clicks');
  localStorage.removeItem('open-reports');
  localStorage.removeItem('alreadyFilledMenu');
  localStorage.removeItem('clickReportsControl');
  localStorage.removeItem('scrollActivated');
  localStorage.removeItem('payload-getUploadLink');
  localStorage.removeItem('defaultArrCopy');
};

export const moveNoAnswerToEnd = (arr, view: string) => {
  const index = arr.findIndex((entry) => entry[view] === 'No Answer');
  if (index !== -1) {
    const [noAnswerEntry] = arr.splice(index, 1);
    arr.push(noAnswerEntry);
  }
  return arr;
};

export const countUniqueDataFrom = (data, view: string) => {
  const counts = {};
  data.forEach((row) => {
    const code = String(row[view]);
    if (code.includes('*')) return;
    if (counts[code]) {
      counts[code]++;
    } else {
      counts[code] = 1;
    }
  });
  const uniqueCount = Object.keys(counts).length;
  return uniqueCount;
};

import { useLocation } from 'react-router-dom';

function hasNumber(str) {
  return /\d/.test(str); // Checks if there's at least one digit (0-9)
}

// Custom hook - must start with "use" to follow React's rules of hooks
export const useIsLillyFile = () => {
  const location = useLocation().pathname;
  const idFile = getWorkspace(location);
  const files: any = getLocalStorage('FilesSelected');
  const fileDetails = files?.find((e) => e.id === idFile);

  if (fileDetails) {
    const searchString = fileDetails?.name ?? undefined;
    if (
      searchString &&
      (searchString == 'Lilly_Main' ||
        searchString == 'Lilly_Positive_Feedback' ||
        searchString == 'Lilly_Improvement_Feedback' ||
        searchString == 'Lilly_Suggestions')
    ) {
      return true;
    }
  }
  return false;
};

// Legacy export for backward compatibility (just an alias)
export const isLillyFile = useIsLillyFile;

function isValidIUniqueValuesPair(value1, value2) {
  const validPairs = [
    [0, 1],
    [1, 0],
    ['0', '1'],
    ['1', '0'],
    ['True', 'False'],
    ['False', 'True'],
    ['true', 'false'],
    ['false', 'true'],
    ['Yes', 'No'],
    ['No', 'Yes'],
    ['yes', 'no'],
    ['no', 'yes']
  ];

  if (
    validPairs.some(
      (pair) =>
        (pair[0] === value1 && pair[1] === value2) || (pair[1] === value1 && pair[0] === value2)
    )
  ) {
    return true;
  }

  if (
    (value1 === '' && typeof value2 === 'string' && value2 !== '') ||
    (value2 === '' && typeof value1 === 'string' && value1 !== '')
  ) {
    return true;
  }

  if (
    (value1 === 'No answer' &&
      typeof value2 === 'string' &&
      value2 !== 'No answer' &&
      value2 !== '') ||
    (value2 === 'No answer' &&
      typeof value1 === 'string' &&
      value1 !== 'No answer' &&
      value1 !== '')
  ) {
    return true;
  }

  return false;
}

function uniqueValuesArraysEqual(arrayA, arrayB) {
  if (arrayA.length !== arrayB.length) return false;

  const usedIndexesB = new Set();

  for (const itemA of arrayA) {
    const indexB = arrayB.findIndex(
      (itemB, idx) => !usedIndexesB.has(idx) && isValidIUniqueValuesPair(itemA, itemB)
    );
    if (indexB == -1) {
      return false;
    }
    usedIndexesB.add(indexB);
  }

  return true;
}

export const isColumnGroupable = (label: string, data) => {
  let isGroupable = false;
  if (label && label.length > 0 && data && data.length > 0) {
    const columnSelected = data.find((r) => r.label == label);
    if (columnSelected) {
      const uniqueValues = columnSelected.countValues;
      const previousColumn = data.find((r) => r.fieldPosition == columnSelected.fieldPosition - 1);
      const nextColumn = data.find((r) => r.fieldPosition == columnSelected.fieldPosition + 1);
      if (uniqueValues < 3) {
        let nextCol = false;
        let prevCol = false;
        let rule0UniqueValue1 = false;
        let rule0UniqueValue2 = false;
        let rule1UniqueValue1 = false;
        let rule1UniqueValue2 = false;
        let rule2UniqueValue1 = false;
        let rule2UniqueValue2 = false;
        let rule2UniqueValue3 = false;
        let rule2UniqueValue4 = false;

        if (uniqueValues == 0) {
          nextCol = nextColumn && (nextColumn?.countValues == 0 || nextColumn?.countValues == 1);
          prevCol =
            previousColumn &&
            (previousColumn?.countValues == 0 || previousColumn?.countValues == 1);
          rule0UniqueValue1 = columnSelected.fieldPosition == 0 && nextCol;
          rule0UniqueValue2 = columnSelected.fieldPosition > 0 && (nextCol || prevCol);
        } else if (uniqueValues == 1) {
          nextCol =
            nextColumn &&
            (nextColumn?.countValues == 0 || nextColumn?.countValues == 1) &&
            columnSelected.dataType == nextColumn?.dataType;
          prevCol =
            previousColumn &&
            (previousColumn?.countValues == 0 || previousColumn?.countValues == 1) &&
            columnSelected.dataType == previousColumn?.dataType;
          rule1UniqueValue1 = columnSelected.fieldPosition == 0 && nextCol;
          rule1UniqueValue2 = columnSelected.fieldPosition > 0 && (nextCol || prevCol);
        } else if (uniqueValues == 2 && columnSelected.unique_entries?.length == 2) {
          rule2UniqueValue1 =
            columnSelected.fieldPosition == 0 && nextColumn && nextColumn?.countValues == 0;
          rule2UniqueValue2 =
            columnSelected.fieldPosition > 0 &&
            (nextColumn?.countValues == 0 || previousColumn?.countValues == 0);
          nextCol =
            nextColumn &&
            nextColumn?.countValues == 2 &&
            columnSelected.unique_values?.length > 0 &&
            uniqueValuesArraysEqual(columnSelected.unique_values, nextColumn?.unique_values);
          prevCol =
            previousColumn &&
            previousColumn?.countValues == 2 &&
            columnSelected.unique_values?.length > 0 &&
            previousColumn?.unique_values?.length > 0 &&
            uniqueValuesArraysEqual(columnSelected.unique_values, previousColumn?.unique_values);
          rule2UniqueValue3 = columnSelected.fieldPosition == 0 && nextCol;
          rule2UniqueValue4 = columnSelected.fieldPosition > 0 && (nextCol || prevCol);
        }

        if (
          rule0UniqueValue1 ||
          rule0UniqueValue2 ||
          rule1UniqueValue1 ||
          rule1UniqueValue2 ||
          rule2UniqueValue1 ||
          rule2UniqueValue2 ||
          rule2UniqueValue3 ||
          rule2UniqueValue4
        ) {
          isGroupable = true;
        }
      }
    }
  }

  return isGroupable;
};

export const isColumnGroupableNextOne = (columnSelected: any, data) => {
  let isGroupable = false;
  if (columnSelected.label == data.label) {
    isGroupable = true;
  } else if (columnSelected) {
    const uniqueValues = columnSelected.countValues;
    if (uniqueValues < 3) {
      let nextCol = false;
      let prevCol = false;
      let rule0UniqueValue1 = false;
      let rule0UniqueValue2 = false;
      let rule1UniqueValue1 = false;
      let rule1UniqueValue2 = false;
      let rule2UniqueValue1 = false;
      let rule2UniqueValue2 = false;
      let rule2UniqueValue3 = false;
      let rule2UniqueValue4 = false;

      if (uniqueValues == 0) {
        nextCol = data && (data?.countValues == 0 || data?.countValues == 1);
        prevCol = data && (data?.countValues == 0 || data?.countValues == 1);
        rule0UniqueValue1 = columnSelected.fieldPosition == 0 && nextCol;
        rule0UniqueValue2 = columnSelected.fieldPosition > 0 && (nextCol || prevCol);
      } else if (uniqueValues == 1) {
        nextCol =
          data &&
          (data?.countValues == 0 || data?.countValues == 1) &&
          columnSelected.dataType == data?.dataType;
        prevCol =
          data &&
          (data?.countValues == 0 || data?.countValues == 1) &&
          columnSelected.dataType == data?.dataType;
        rule1UniqueValue1 = columnSelected.fieldPosition == 0 && nextCol;
        rule1UniqueValue2 = columnSelected.fieldPosition > 0 && (nextCol || prevCol);
      } else if (uniqueValues == 2 && columnSelected.unique_entries?.length == 2) {
        rule2UniqueValue1 = columnSelected.fieldPosition == 0 && data && data?.countValues == 0;
        rule2UniqueValue2 =
          columnSelected.fieldPosition > 0 && (data?.countValues == 0 || data?.countValues == 0);
        nextCol =
          data &&
          data?.countValues == 2 &&
          columnSelected.unique_values?.length > 0 &&
          uniqueValuesArraysEqual(columnSelected.unique_values, data?.unique_values);
        prevCol =
          data &&
          data?.countValues == 2 &&
          columnSelected.unique_values?.length > 0 &&
          data?.unique_values?.length > 0 &&
          uniqueValuesArraysEqual(columnSelected.unique_values, data?.unique_values);
        rule2UniqueValue3 = columnSelected.fieldPosition == 0 && nextCol;
        rule2UniqueValue4 = columnSelected.fieldPosition > 0 && (nextCol || prevCol);
      }

      if (
        rule0UniqueValue1 ||
        rule0UniqueValue2 ||
        rule1UniqueValue1 ||
        rule1UniqueValue2 ||
        rule2UniqueValue1 ||
        rule2UniqueValue2 ||
        rule2UniqueValue3 ||
        rule2UniqueValue4
      ) {
        isGroupable = true;
      }
    }
  }

  return isGroupable;
};

export const replaceUniqueValues = (values, oldValue, newValue) => {
  return values.map((entry) =>
    typeof entry == 'number' && entry == oldValue
      ? parseFloat(newValue)
      : typeof entry == 'string' && entry == oldValue
      ? newValue
      : entry
  );
};

export const handleGetPro = () => {
  window.open(
    'https://connect.intuit.com/pay/DrumrollHealthInc/scs-v1-c592eb9e4f52484399878a24ee076bfeed0040e67b514a50be0c28fc1bff6872aa766feba1014854bd088f3166bd83b9?locale=EN_US',
    '_blank'
  );
};

export const handleGetStarter = () => {
  window.open(
    'https://connect.intuit.com/pay/DrumrollHealthInc/scs-v1-a76ce743d55a4eb1b111798fd6d8d8ec57dfc1d1fde1478fadf8b4ed14c5e9208112dc0306f34da0b92117d2930b1273?locale=EN_US',
    '_blank'
  );
};

export const handleGetFree = () => {
  window.open('/email_verification', '_self');
};

export const getArryNumbersAtString = (value: string) => {
  const match = value.match(/\[(.*?)\]/);
  if (match) {
    const arrayValues = match[1].split(',').map((value) => value.trim());
    const count = arrayValues.length;
    return count;
  } else {
    return 0;
  }
};

export const getValuesFromArryNumbersAtString = (value: string) => {
  const match = value.match(/\[(.*?)\]/);
  if (match) {
    const arrayValues = match[1].split(',').map((value) => value.trim());
    const formattedValues = arrayValues.join(', ').replace(/, ([^,]*)$/, ' and $1');
    return formattedValues;
  } else {
    return '';
  }
};

export const calculateCorrelationData = (data, filterArray) => {
  let filterColdata: any[] = [];
  const colData: any[] = [];
  if (data && filterArray) {
    data?.forEach((element, i) => {
      const pct = element?.percent ?? element.correlation * 100;
      const dataPayload = {
        columnName: element?.columnName ?? element.column,
        strength: [pct < 0 ? pct * -1 : pct],
        ratio: roundNumber(pct < 0 ? pct * -1 : pct, 2),
        total: data.length,
        index: i + 1,
        strenghNumber: pct < 0 ? pct * -1 : pct,
        column: '',
        items: element.values
      };
      colData.push(dataPayload);
    });

    const dataMap = Object.keys(filterArray)?.map((key) => [key, filterArray[key]]);
    const excludeCols: any[] = [];
    dataMap.forEach((element) => {
      excludeCols.push(element[0]);
    });
    colData.forEach((element) => {
      const existCol = excludeCols.find((e) => e == element.columnName);
      if (!existCol) {
        filterColdata.push(element);
      }
    });
  }

  return filterColdata;
};

const getOrderViews = (viewDataSelected) => {
  const views: string[] = [];

  viewDataSelected?.forEach((element) => {
    if (element) {
      views.push(element.view || element.columnNameServer);
    }
  });

  return views;
};

export const calculateCohortsData = (
  payload,
  response,
  onlyIncludedViews,
  viewDataSelected,
  fromAIBubble: boolean
) => {
  const defaultData: any[] = [];
  const dataJoin: any[] = [];
  const dataLoop = response?.data ?? response;
  dataLoop?.forEach((element) => {
    const data: any[] = [];
    for (const [key, value] of Object.entries(element)) {
      if (!payload.headViews.includes(key)) {
        const detailsArr: any[] = [];
        const values: any = value;
        for (const [key, value] of Object.entries(values?.details)) {
          const maxMarkedD = 'max-marked';
          const minMarkedD = 'min-marked';
          const pvalue = 'baseline-pvalue';
          const itemsDetail = {
            name: typeof key == 'string' ? key.replace(/\.0+/g, '') : key,
            fp: (value as any).pct,
            marked: (value as any)[maxMarkedD] ?? false,
            pvalue: (value as any)[pvalue] ?? null,
            minMarked: (value as any)[minMarkedD] ?? null
          };
          detailsArr.push(itemsDetail);
        }
        const viewFound = onlyIncludedViews?.find((r) => (r.view || r.columnNameServer) == key);
        const weight = values['max-weight'] ?? 0;
        const minWeight = values['min-weight'] ?? 0;
        const overlap = values['max-overlap'] ?? null;
        const minOverlap = values['min-overlap'] ?? null;
        const items = {
          view: key,
          details: detailsArr,
          weight: weight?.toFixed(1) ?? 0,
          minWeight: minWeight?.toFixed(1) ?? 0,
          overlap: overlap ?? null,
          type: viewFound ? viewFound.type : '',
          minOverlap: minOverlap ?? null
        };
        data.push(items);
      }
    }
    dataJoin.push(data);
  });
  const views = getOrderViews(viewDataSelected);
  const concat: any[] = [];
  const dataJoinFiltered1 = payload.existsComparisonData
    ? dataJoin[0].filter((e) =>
        onlyIncludedViews
          ?.map((e) => e.view || e.columnNameServer)
          ?.find((r) => r === (e.view || e.columnNameServer))
      )
    : [];
  const dataJoinFiltered2 = payload.existsComparisonData
    ? dataJoin[1]?.filter((e) =>
        onlyIncludedViews
          ?.map((e) => e.view || e.columnNameServer)
          ?.find((r) => r === (e.view || e.columnNameServer))
      )
    : [];
  concat.push(dataJoinFiltered1);
  concat.push(dataJoinFiltered2);
  const groupDetailsData = {
    data: payload.existsComparisonData
      ? concat
      : dataJoin[0].filter((e) =>
          onlyIncludedViews
            ?.map((e) => e.view || e.columnNameServer)
            ?.find((r) => r === (e.view || e.columnNameServer))
        ),
    hasComparisonVales: payload.existsComparisonData
  };

  const groupDetailsDataAsc = {
    data: JSON.parse(JSON.stringify(groupDetailsData.data)),
    hasComparisonVales: payload.existsComparisonData
  };

  const groupDetailsDataMinWeight = {
    data: JSON.parse(JSON.stringify(groupDetailsData.data)),
    hasComparisonVales: payload.existsComparisonData
  };

  const groupDetailsDataMinWeightAsc = {
    data: JSON.parse(JSON.stringify(groupDetailsData.data)),
    hasComparisonVales: payload.existsComparisonData
  };

  const arrayDefaultAnalysis: any[] = [];
  const arrayDefaultComparison: any[] = [];

  views?.forEach((element) => {
    const exists = dataJoin[0]
      .filter((e) =>
        onlyIncludedViews
          ?.map((e) => e.view || e.columnNameServer)
          ?.find((r) => r === (e.view || e.columnNameServer))
      )
      .find((e) => e.view === element);
    if (exists) {
      arrayDefaultAnalysis.push(exists);
    }
  });

  // if (!fromAIBubble)
  defaultData.push(arrayDefaultAnalysis);

  // if (fromAIBubble) {
  //   defaultData.push(dataJoin[0]);
  //   defaultData.push(dataJoin[1]);
  // }

  if (payload.existsComparisonData) {
    views?.forEach((element) => {
      const exists = dataJoin[1]
        .filter((e) =>
          onlyIncludedViews
            ?.map((e) => e.view || e.columnNameServer)
            ?.find((r) => r === (e.view || e.columnNameServer))
        )
        .find((e) => (e.view || e.columnNameServer) === element);
      if (exists) {
        arrayDefaultComparison.push(exists);
      }
    });
    // if (!fromAIBubble)
    defaultData.push(arrayDefaultComparison);
  }

  const groupDefaultDetailsData = {
    data: payload.existsComparisonData ? defaultData : defaultData[0],
    hasComparisonVales: payload.existsComparisonData
  };

  if (payload.existsComparisonData) {
    groupDetailsData.data[0].sort((a, b) => parseFloat(b.weight) - parseFloat(a.weight));
    groupDetailsDataAsc.data[0].sort((a, b) => parseFloat(a.weight) - parseFloat(b.weight));
    groupDetailsDataMinWeight.data[0].sort(
      (a, b) => parseFloat(b.minWeight) - parseFloat(a.minWeight)
    );
    groupDetailsDataMinWeightAsc.data[0].sort(
      (a, b) => parseFloat(a.minWeight) - parseFloat(b.minWeight)
    );
  } else {
    groupDetailsData.data.sort((a, b) => parseFloat(b.weight) - parseFloat(a.weight));
    groupDetailsDataAsc.data.sort((a, b) => parseFloat(a.weight) - parseFloat(b.weight));
    groupDetailsDataMinWeight.data.sort(
      (a, b) => parseFloat(b.minWeight) - parseFloat(a.minWeight)
    );
    groupDetailsDataMinWeightAsc.data.sort(
      (a, b) => parseFloat(a.minWeight) - parseFloat(b.minWeight)
    );
  }

  return {
    groupDetailsData: groupDetailsData,
    groupDefaultDetailsData: groupDefaultDetailsData,
    groupDetailsDataAsc: groupDetailsDataAsc,
    groupDetailsDataMinWeight: groupDetailsDataMinWeight,
    groupDetailsDataAscMinWeight: groupDetailsDataMinWeightAsc
  };
};

export const calculateSignalsDatav1 = (data) => {
  let numPrevious = 0;
  const rows: any[] = [];
  let accumulativeValue = 0;
  data.forEach((element, index: number) => {
    let previousPct = 0;
    element.signal.forEach((signalValue) => {
      const pct =
        typeof signalValue.acc === 'string' ? parseFloat(signalValue.acc) : signalValue.acc;

      const pctValue = index === 0 ? roundDown(pct, 0) : roundDown(pct, 0) - previousPct;
      const signalSelected = signalValue.signal;
      const isNegative = signalSelected[1] === 'is not' ? true : false;
      const isRange = signalSelected[1] === 'is in the range' ? true : false;
      const isNotRange = signalSelected[1] === 'is not in the range' ? true : false;
      const is = signalSelected[1] === 'is' ? true : false;
      const isNotOneOf = signalSelected[1] === 'is not one of' ? true : false;
      const isOneOf = signalSelected[1] === 'is one of' ? true : false;

      const payload = {
        field: signalSelected[0],
        values:
          signalSelected[2] && typeof signalSelected[2] !== 'string' && signalSelected[2].length > 1
            ? signalSelected[2].length === 2 && (isRange || isNotRange)
              ? signalSelected[2]
              : signalSelected[2].join(', ')
            : signalSelected[2],
        pct: roundDown(pct, 0) - previousPct,
        pctn: numPrevious,
        pctLabel: roundDown(pct, 0),
        pctLabelPrev: previousPct,
        isNegative: isNegative,
        isRange: isRange,
        isNotRange: isNotRange,
        is: is,
        isNotOneOf: isNotOneOf,
        isOneOf: isOneOf
      };
      numPrevious = numPrevious + pctValue + 1;
      rows.push(payload);
      accumulativeValue += pctValue;
      previousPct = roundDown(pct, 0);
    });
  });

  return rows;
};

export const calculateSignalsData = (data) => {
  let numPrevious = 0;
  let supportTotal = 0;
  const rows: any[] = [];
  let accumulativeValue = 0;
  let previousPct = 0;
  data.forEach((element, index: number) => {
    const pct = typeof element.prob === 'string' ? parseFloat(element.prob) : element.prob;
    const support =
      typeof element.support === 'string' ? parseFloat(element.support) : element.support;
    const pctValue = index === 0 ? roundDown(pct, 2) : roundDown(pct, 2) - previousPct;
    supportTotal += roundDown(support, 2);
    const payload = {
      field: element.description,
      pct: roundDown(pct, 2) - previousPct,
      pctn: numPrevious,
      pctLabel: roundDown(pct, 2),
      pctLabelPrev: previousPct,
      support: roundDown(support, 2),
      supportTotal: supportTotal,
      feature: element.feature
    };
    numPrevious = numPrevious + pctValue + 1;
    rows.push(payload);
    accumulativeValue += pctValue;
    previousPct = roundDown(pct, 2);
  });

  return rows;
};

function compareObjects(obj1, obj2) {
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }

  for (const key in obj1) {
    if (obj1.hasOwnProperty(key)) {
      if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
        if (!compareObjects(obj1[key], obj2[key])) {
          return false;
        }
      } else if (obj1[key] !== obj2[key]) {
        return false;
      }
    }
  }

  return true;
}

export const compareArrays = (array1, array2) => {
  if (array1.length !== array2.length) {
    return false;
  }

  for (let i = 0; i < array1.length; i++) {
    if (!compareObjects(array1[i], array2[i])) {
      return false;
    }
  }

  return true;
};

export const stripHtml = (html) => {
  let doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

// export const StarterAnnualPrice = 'price_1PyEzBAxqkh8jfgjJlvPOUml';
// export const StarterMonthlyPrice = 'price_1Q0kXcAxqkh8jfgjXmJXnyzx';
// export const ProAnnualPrice = 'price_1PyFCZAxqkh8jfgjjNemejcl';
// export const ProMonthlyPrice = 'price_1Q0kWRAxqkh8jfgjXzFgpvHO';
export const StarterAnnualPrice = 'price_1R59liAxqkh8jfgjwkCAHawW';
export const StarterMonthlyPrice = 'price_1R59ksAxqkh8jfgj4DhgteaM';
export const ProAnnualPrice = 'price_1R59joAxqkh8jfgjuvj4DDYo';
export const ProMonthlyPrice = 'price_1R59hjAxqkh8jfgjALr00ydH';
export const FreePrice = 'price_1Q0lLIAxqkh8jfgjMjEggCJF';
export const PublicKeyStripe =
  'pk_live_51PyEH3Axqkh8jfgjNz64nXH8s9lmM9PQeimuAPIoiBjoYZ5CCL9rI1qlnrB0VOC8V86OPhGeF8ncNZNsmKDPBKHo004oxnAbT8';

export const FreePriceTest = 'price_1QgttrAxqkh8jfgjUdIXpZc7';
export const StarterAnnualPriceTest = 'price_1R4qDwAxqkh8jfgjSZtEzLqJ';
export const StarterMonthlyPriceTest = 'price_1R4qAUAxqkh8jfgj7c0rmRyK';
export const ProAnnualPriceTest = 'price_1R4qqLAxqkh8jfgj3uPl5JZT';
export const ProMonthlyPriceTest = 'price_1R4qpfAxqkh8jfgj0YddbOtC';
export const PublicKeyStripeTest =
  'pk_test_51PyEH3Axqkh8jfgjFZz7zlOjzEAtfWpClfHFDD284kmPPCW8pc0XXxrL2118bIJZd4suzPcfikyy9H6t2DYmOS9A00Xxng3SRq';

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const hasWeirdCharacters = (str) => {
  return /[^\x00-\x7F]/.test(str);
};

export const downloadFile = (fileName: string) => {
  const link = document.createElement('a');
  link.href = `/files/${fileName}`;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getExcelColumnLetters = (numbers) => {
  return numbers
    .map((number) => {
      let columnLetter = '';
      while (number > 0) {
        const remainder = (number - 1) % 26;
        columnLetter = String.fromCharCode(65 + remainder) + columnLetter;
        number = Math.floor((number - 1) / 26);
      }
      return columnLetter;
    })
    .join(' - ');
};

export const truncateText = (text, charLimit = 10) => {
  if (charLimit == 0) {
    return '';
  }
  if (text.length > charLimit) {
    return text.slice(0, charLimit) + '...';
  }
  return text;
};

export const getBreakDownValues = (data, viewSelected, breakDownSelected) => {
  const result: any[] = [];
  data.forEach((element) => {
    if (element[viewSelected] !== '*' && element[breakDownSelected] !== '*') {
      if (typeof element[viewSelected] === 'number') {
        element[viewSelected] = element[viewSelected].toString();
      }
      result.push(element);
    }
  });
  return result;
};

export const getTotalsBreakdownSelected = (data, viewSelected, breakDownSelected) => {
  const result: any[] = [];
  data.forEach((element) => {
    if (element[viewSelected] === '*' && element[breakDownSelected] !== '*') {
      result.push(element);
    }
  });
  return result;
};

export const transformArrFilterBox = (input) => {
  return Object.entries(input).map(([key, values]) => ({
    parent: key,
    children: (values as any).join(', ')
  }));
};

export const formatArrayWithCommasAnd = (arr, pageFrom) => {
  if (arr.length === 0) return '';
  if (arr.length === 1)
    return `<span class='text-[#364152] border-[1px] border-solid border-[#788AA6] bg-[#E3E8EF] rounded-[5px] px-[1px] font-mono ${
      pageFrom == 'ai-page' ? 'text-[13px]' : 'text-xs'
    }'>${arr[0]}</span> `;
  const lastElement = arr.pop();
  return `  ${arr
    .map(
      (item) =>
        `<span class='text-[#364152] border-[1px] border-solid border-[#788AA6] bg-[#E3E8EF] rounded-[5px] px-[1px] font-mono ${
          pageFrom == 'ai-page' ? 'text-[13px]' : 'text-xs'
        }'>${item}</span>`
    )
    .join(
      ', '
    )} and <span class='text-[#364152] border-[1px] border-solid border-[#788AA6] bg-[#E3E8EF] rounded-[5px] px-[1px] font-mono ${
    pageFrom == 'ai-page' ? 'text-[13px]' : 'text-xs'
  }'>${lastElement}</span>`;
};

export const combineValuesFromColumns = (inputs) => {
  return Object.values(inputs).flat();
};

export const customComparator = (valueA, valueB) => {
  if (valueA === 'No Answer') {
    return 1;
  }
  if (valueB === 'No Answer') {
    return -1;
  }
  if (valueA < valueB) {
    return -1;
  }
  if (valueA > valueB) {
    return 1;
  }
  return 0;
};

export const convertArrToIntSum = (props: any) => {
  let sum = 0;
  const arrValues = props?.values?.map((e) =>
    typeof e === 'string' && e?.includes(',')
      ? parseFloat(e.replace(',', ''))
      : typeof e === 'string' && e?.includes('%')
      ? parseFloat(e?.split('%')[0])
      : typeof e === 'string' && e?.includes('.')
      ? parseFloat(getCleanNumber(e))
      : parseFloat(e)
  );
  const arrSum = arrValues && arrValues.length > 0 ? arrValues : props?.values;
  arrSum?.forEach(function (value) {
    sum += parseFloat(value ?? 0);
  });
  return formatNumber(roundNumber(sum, 2));
};

export function valueGetter(params) {
  const type = params.colDef.field;
  const count = params.data?.count;
  const totalCount = params.data?.totalCount;
  const parseCount = count ? parseFloat(count.replace(/[^0-9.-]/g, '')) : 0;
  const parseTotalCount = totalCount ? parseFloat(totalCount.replace(/[^0-9.-]/g, '')) : 0;
  const parseBreakdown =
    params && params?.data && params?.colDef?.field && params?.data[params?.colDef?.field]
      ? parseFloat(params.data[params.colDef.field].replace(/[^0-9.-]/g, ''))
      : 0;

  return type == 'totalCount' ? parseTotalCount : type == 'count' ? parseCount : parseBreakdown;
}

export const sanitizeGoogleSheetURL = (url) => {
  const baseURL = url.match(/https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+/);
  if (baseURL) {
    return `${baseURL[0]}/export?format=xlsx`;
  }
  throw new Error('Invalid Google Sheets URL');
};

export const sortByCustomOrder = (details: any[], order: string[]) => {
  const orderMap = new Map(order.map((name, index) => [name, index]));
  return details.sort((a, b) => {
    const indexA = orderMap.get(a.name) ?? Number.MAX_SAFE_INTEGER;
    const indexB = orderMap.get(b.name) ?? Number.MAX_SAFE_INTEGER;
    return indexA - indexB;
  });
};

export const sortByCustomGeneralOrder = (details: any[], order: string[]) => {
  const orderMap = new Map(order.map((view, index) => [view, index]));
  return details.sort((a, b) => {
    const indexA = orderMap.get(a.view) ?? Number.MAX_SAFE_INTEGER;
    const indexB = orderMap.get(b.view) ?? Number.MAX_SAFE_INTEGER;
    return indexA - indexB;
  });
};

export const convertStringToNumberCohorts = (value: string) => {
  const input = value?.includes('%') ? value.split('%')[0] : value;
  const num = parseFloat(input);
  return num === 0 ? 0 : num;
};

export const capitalizeFirstLetterOnly = (str: string) => {
  if (!str) return '';
  if (typeof str !== 'string') return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const convertCohortsCounterToNumber = (value: string) => {
  if (value.includes('%')) {
    return parseFloat(value.split('%')[0]);
  }
  return parseFloat(value);
};

export const formatDataForPieChart = (
  filterData: number[],
  unfilterData: number[],
  headers: string[],
  view: string
): (string | number)[][] => {
  // Create header row
  const result: (string | number)[][] = [[view, 'Filtered', 'Unfiltered']];

  // Combine the data
  headers.forEach((header, index) => {
    result.push([header, filterData[index], unfilterData[index]]);
  });

  return result;
};

export const fixAndParseInvalidJson = (str) => {
  let fixedStr = str;
  const propertyRegex = /(\w+\s+\w+):/g;
  const matches = [...str.matchAll(propertyRegex)];
  matches.forEach((match) => {
    const propName = match[1];
    fixedStr = fixedStr.replace(`${propName}:`, `"${propName}":`);
  });
  fixedStr = fixedStr.replace(/(\b\w+):/g, '"$1":');
  fixedStr = fixedStr.replace(/'/g, '"');
  try {
    return Function('return ' + fixedStr)();
  } catch (error) {
    console.error('Parsing error:', error);
    return null;
  }
};

export const updateAppNames = (rows) => {
  return rows.map((row) => {
    const appName = row.app.toLowerCase();
    if (appName === 'reports') {
      return { ...row, app: 'Distribution Analysis' };
    }
    if (appName === 'signals') {
      return { ...row, app: 'Predictive Analysis' };
    }
    if (appName === 'group comparison' || appName === 'cohorts') {
      return { ...row, app: 'Comparative Analysis' };
    }
    if (appName === 'correlations') {
      return { ...row, app: 'Correlation Analysis' };
    }
    if (appName === 'data grid' || appName === 'grid') {
      return { ...row, app: 'Exploratory Analysis' };
    }
    return row;
  });
};

// Export clear selection utilities
export {
  clearReportsSelection,
  clearClusterSelection,
  clearCorrelationSelection
} from './utils/clearSelection';
